import { Create, SimpleForm, useNotify } from "react-admin";

import BackButtonToolbar from "features/BackButtonToolbar";
import CyclicScheduleForm from "./CyclicScheduleForm";
import { checkProps } from "utils/validations";

const CreateCyclicSchedule = () => {
  const notify = useNotify();
  return (
    <Create
      title="Създаване на поток"
      actions={<BackButtonToolbar />}
      onError={error => {
        checkProps(error, notify);
      }}
    >
      <SimpleForm>
        <CyclicScheduleForm />
      </SimpleForm>
    </Create>
  );
};
export default CreateCyclicSchedule;
